import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/compat/app';

export const useAuth = () => {
  return useAuthState(firebase.auth());
};
